module.exports = __webpack_public_path__ + "blue_icon.svg?923c5d55d50bb52768cfa7d99096e148";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/blue_icon.svg
// module id = 11
// module chunks = 2